import { Box, type BoxProps } from "@chakra-ui/react";
import { useKeyboardScrollable } from "./hooks/useKeyboardScrollable";

export const KEYBOARD_SCROLL_FOCUS = { outline: "2px solid", outlineColor: "smPrimary", outlineOffset: "-2px" };

export const KeyboardScrollBox = (props: BoxProps) => {
  const { ref, tabIndex } = useKeyboardScrollable<HTMLDivElement>();
  return <Box ref={ref} tabIndex={tabIndex} _focusVisible={KEYBOARD_SCROLL_FOCUS} {...props} />;
};
